import React from 'react';
import { CONTACT } from '../data/site';
import { Instagram, Facebook } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="relative border-t border-char/10 pt-20 pb-10 px-6 md:px-10 max-w-[1600px] mx-auto" data-testid="footer">
      <div className="grid grid-cols-12 gap-6 md:gap-10">
        <div className="col-span-12 md:col-span-5">
          <div className="font-serif text-4xl md:text-5xl leading-none">
            Ô <em className="italic text-gold">Fil</em> des Verres
          </div>
          <p className="mt-6 text-char/60 max-w-md">
            Bar à cocktails événementiel & bar mobile — basé à Montpellier, déplacement dans tout le Sud de la France. Un service haut de gamme pour vos plus belles réceptions.
          </p>
          <div className="mt-8 flex items-center gap-4">
            <a href={CONTACT.instagram} target="_blank" rel="noreferrer" className="w-10 h-10 border border-char/15 flex items-center justify-center hover:border-gold hover:text-gold transition-colors" data-testid="footer-instagram" aria-label="Instagram">
              <Instagram size={16} strokeWidth={1.4} />
            </a>
            <a href={CONTACT.facebook} target="_blank" rel="noreferrer" className="w-10 h-10 border border-char/15 flex items-center justify-center hover:border-gold hover:text-gold transition-colors" data-testid="footer-facebook" aria-label="Facebook">
              <Facebook size={16} strokeWidth={1.4} />
            </a>
          </div>
        </div>

        <div className="col-span-6 md:col-span-3">
          <div className="overline mb-6">Navigation</div>
          <ul className="space-y-3 text-char/70">
            {[['about', 'Maison'], ['prestations', 'Prestations'], ['bar', 'Bar mobile'], ['cocktails', 'Cocktails'], ['faq', 'FAQ']].map(([id, l]) => (
              <li key={id}>
                <button onClick={() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })} className="link-underline hover:text-char" data-testid={`footer-nav-${id}`}>
                  {l}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="col-span-6 md:col-span-4">
          <div className="overline mb-6">Contact</div>
          <ul className="space-y-3 text-char/70">
            <li><a className="hover:text-gold" href={`tel:${CONTACT.phoneIntl}`}>{CONTACT.phone}</a></li>
            <li><a className="hover:text-gold" href={`mailto:${CONTACT.email}`}>{CONTACT.email}</a></li>
            <li>Montpellier · Occitanie · Sud de la France</li>
          </ul>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-char/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 text-xs text-char/50">
        <div>© {new Date().getFullYear()} Ô Fil des Verres. Tous droits réservés.</div>
        <div className="flex gap-6">
          <a href="#" className="hover:text-char">Mentions légales</a>
          <a href="#" className="hover:text-char">Politique de confidentialité</a>
        </div>
      </div>
    </footer>
  );
}
